// ** Icon imports
import VideoBox from "mdi-material-ui/VideoBox";

// The vertical nav is hidden app-wide (themeConfig navHidden). Only the
// course list entry remains; /messages and /wishlist pages were removed.
const navigation = () => {
  return [
    {
      title: "Os meus Cursos",
      icon: VideoBox,
      path: "/home",
    },
  ];
};

export default navigation;
